import BritishFlagSvg from '@assets/images/flags/en.svg';
import NorwegianFlagSvg from '@assets/images/flags/nb.svg';
import SwedishFlagSvg from '@assets/images/flags/sv.svg';
import FinnishFlagPng from '@assets/images/flags/fi.png';
import { UserResponse } from '@services/authApi';
import { Locale } from 'types/locale';

export interface ICountryInfo {
  language: string;
  flag: string;
  displayName: string;
}

interface ICountryInfoMap {
  [key: string]: ICountryInfo;
}

export const COUNTRY_INFO: ICountryInfoMap = {
  en: { language: 'en', flag: BritishFlagSvg, displayName: 'English' },
  no: { language: 'nb', flag: NorwegianFlagSvg, displayName: 'Norsk' },
  se: { language: 'sv', flag: SwedishFlagSvg, displayName: 'Svenska' },
  fi: { language: 'fi', flag: FinnishFlagPng, displayName: 'Suomi' },
};

export const selectLanguageInfoToDisplay = (
  user: UserResponse,
  currentLanguageIsoCode: string,
  userCountryIsoCode?: string
): ICountryInfo => {
  if (!user?.signedIn && COUNTRY_INFO[currentLanguageIsoCode]) {
    return COUNTRY_INFO[currentLanguageIsoCode];
  }
  if (
    currentLanguageIsoCode === 'en' &&
    userCountryIsoCode &&
    COUNTRY_INFO[userCountryIsoCode]
  ) {
    return COUNTRY_INFO[userCountryIsoCode];
  }
  return COUNTRY_INFO['en'];
};

export const toggleLanguage = (
  user: UserResponse,
  locale: Record<string, any>,
  setLocale: (value: React.SetStateAction<Locale>) => void,
  closeLanguageMenu: () => void,
  language?: string
) => {
  const userCountryIsoCode = user?.country?.isocode;

  let newIsoCode: string;
  let newLanguage: string;

  if (user && user.signedIn) {
    newIsoCode = locale?.country === 'en' ? userCountryIsoCode : 'en';
    newLanguage = COUNTRY_INFO[newIsoCode]?.language || 'en';
  } else {
    const languageToCountryMap: { [key: string]: string } = {
      en: 'en',
      nb: 'no',
      sv: 'se',
      fi: 'fi',
    };

    newLanguage = COUNTRY_INFO[language]?.language || 'en';
    newIsoCode = languageToCountryMap[newLanguage] || 'en';
  }

  const newLocale = {
    country: newIsoCode,
    language: newLanguage,
  };

  localStorage.setItem('locale', JSON.stringify(newLocale));
  window.dispatchEvent(new Event('storage'));
  setLocale(newLocale);
  closeLanguageMenu();
};
